import React, { Component } from "react";
import { RTReqProps } from "./RTRequestsListView";
import GridDataView, { GRID_SIZE } from "../DataView/GridDataView";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { RTRequest, RTRequestStatusId } from "@eres/rtregistrationapi/entities";
import {
	getRTReqDate,
	getRTReqProcedureType,
	getRTReqStatus,
	getRTReqStatusClass,
	getRTReqTransactionNo
} from "@my-dld/screens/MyDLD/MyRequest/RTRequests";
import Strings from "@my-dld/assets/strings";

interface State {
	searchKey?: string;
	page: number;
}

class RTRequestsGridView extends Component<RTReqProps, State> {
	constructor( props: RTReqProps ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { items, onShowCancel } = this.props;
		const { searchKey } = this.state;
		const filterData = this.getFilterData( searchKey );
		return <GridDataView
			items={ this.getPageData( filterData ) }
			onSearch={ this.onSearch }
			renderGridItem={ ( item: RTRequest ) => {
				return <RenderGridItem
					key={ "" + item.OnlineRequestId }
					item={ item }
					onShowCancel={ onShowCancel }/>;
			} }
			totalCount={ !isEmptyStringOrNull( searchKey ) ? filterData.length : items.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getFilterData( sKey?: string ) {
		const { items } = this.props;
		if ( sKey ) {
			return items.filter( ( item: RTRequest ) => {
				const filterKeys: string[] = [];
				filterKeys.push( getRTReqTransactionNo( item ) );
				filterKeys.push( getRTReqProcedureType( item ) );
				filterKeys.push( getRTReqStatus( item ) );
				filterKeys.push( getRTReqDate( item ) );
				const fItem = filterKeys.find( ( fKey: string ) => fKey.toLocaleLowerCase().includes( sKey.toLocaleLowerCase() ) );
				return fItem != undefined;
			} );
		}
		return items;
	}

	private getPageData( filterData: RTRequest[] ) {
		const { page } = this.state;
		return filterData.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private onSearch = ( sKey?: string ) => {
		this.setState( {
			searchKey: sKey,
			page: 1
		} );
	};

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

function RenderGridItem( props: { item: RTRequest, onShowCancel: ( item: RTRequest ) => void } ) {
	const { item, onShowCancel } = props;
	const statusId = item.OnlineRequestStatusId;
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getRTReqProcedureType( item ) }</span>
							<span>{ Strings.procedure_type }</span>
						</div>
						<div className={ `property-status ${ getRTReqStatusClass( item ) }` }>
							{ getRTReqStatus( item ) }
						</div>
					</div>
					<div className="row no-gutters property-card-detail">
						<div className="col-6">
							<span>{ getRTReqTransactionNo( item ) }</span>
							<span>{ Strings.transaction_number }</span>
						</div>
						<div className="col-6">
							<span>{ getRTReqDate( item ) }</span>
							<span>{ Strings.submission_date }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-action">
						{ statusId === RTRequestStatusId.PENDING && <div className="col-md-12">
							<button
								className="btn-link" onClick={ () => {
								onShowCancel( item );
							} }>{ Strings.cancel }</button>
						</div> }
					</div>
				</div>
			</div>
		</div>
	</div>;
}

export default RTRequestsGridView;
